import { render } from "./DashboardsListView.vue?vue&type=template&id=f4e674f0"
import script from "./DashboardsListView.vue?vue&type=script&lang=js"
export * from "./DashboardsListView.vue?vue&type=script&lang=js"

import "./DashboardsListView.vue?vue&type=style&index=0&id=f4e674f0&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__